import { Box, Grid, List, ListItem, Theme, Typography, useTheme } from '@mui/material';
import { ClaimProgressEnum } from '../../../types/type';

interface ClaimDetailNextStepsType {
  claimProgressStateType: ClaimProgressEnum;
}

export default function ClaimDetailNextSteps(props: ClaimDetailNextStepsType) {
  const theme: Theme = useTheme();
  let content = <div></div>;
  const contentForEvaluationStage = (
    <>
      <Grid item xs={12}>
        <Typography sx={{ marginTop: '20px' }} variant="body1">
          <b>Here’s what typically happens next: </b>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <List sx={theme.custom.styles.confirmationList}>
          <ListItem sx={theme.custom.styles.confirmationListElement}>
            <Typography variant="body1">You will receive further communication as your claim progresses</Typography>
          </ListItem>
          <ListItem sx={theme.custom.styles.confirmationListElement}>
            <Typography variant="body1">Coverage is assessed</Typography>
          </ListItem>
          <ListItem sx={theme.custom.styles.confirmationListElement}>
            <Typography variant="body1">Damage is assessed</Typography>
          </ListItem>
        </List>
      </Grid>
    </>
  );
  const contentForResolutionStage = (
    <>
      <Grid item xs={12}>
        <Typography sx={{ marginTop: '20px' }} variant="body1">
          <b>Here’s what typically happens next: </b>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <List sx={theme.custom.styles.confirmationList}>
          <ListItem sx={theme.custom.styles.confirmationListElement}>
            <Typography variant="body1">Payment(s) are issued</Typography>
          </ListItem>
          <ListItem sx={theme.custom.styles.confirmationListElement}>
            <Typography variant="body1">Structural repair(s) are discussed</Typography>
          </ListItem>
          <ListItem sx={theme.custom.styles.confirmationListElement}>
            <Typography variant="body1">Damage item(s) are discussed</Typography>
          </ListItem>
        </List>
      </Grid>
    </>
  );
  const contentForClosedStage = (
    <Grid item xs={12}>
      <Typography variant="body1" sx={{ marginTop: '20px' }}>
        This claim is complete.
      </Typography>
      <Typography variant="body1">If you have any questions, please contact us for assistance.</Typography>
    </Grid>
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Grid
        container
        sx={{
          width: '100%',
          maxWidth: '1280px',
          minWidth: '310px',
          margin: '0 auto',
        }}
      >
        {props.claimProgressStateType === ClaimProgressEnum.SUBMISSION ||
        props.claimProgressStateType === ClaimProgressEnum.EVALUATION
          ? (content = contentForEvaluationStage)
          : (content = <div></div>)}
        {props.claimProgressStateType === ClaimProgressEnum.RESOLUTION
          ? (content = contentForResolutionStage)
          : (content = <div></div>)}
        {props.claimProgressStateType === ClaimProgressEnum.CLOSED
          ? (content = contentForClosedStage)
          : (content = <div></div>)}
      </Grid>
    </Box>
  );
}
